/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./voip.vue?vue&type=template&id=94a5cd28&scoped=true&"
import script from "./voip.vue?vue&type=script&lang=js&"
export * from "./voip.vue?vue&type=script&lang=js&"
import style0 from "./voip.vue?vue&type=style&index=0&id=94a5cd28&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a5cd28",
  null
  
)

export default component.exports